import { whenPurposeConsented } from '@/Utils/PrivacyUtility';

/**
 * @param {object} pluginConfig
 * @param {string} pluginConfig.id - Clarity project ID
 */
export default function clarityPlugin(pluginConfig) {
    whenPurposeConsented('Analytics').then(() => {
        window.clarity = window.clarity || function() {
            (window.clarity.q = window.clarity.q || []).push(arguments);
        };

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.clarity.ms/tag/${pluginConfig.id}`;
        document.head.appendChild(script);
    });

    return {
        name: 'clarity',
        config: pluginConfig,
        track: () => {},
    };
}
